// Override Settings
var bcSfSearchSettings = {
    search: {
      //  suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

// Build Pages
BCSfFilter.prototype.buildSuggestionPage = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var result = '';
    if (Object.keys(itemData).length > 0) {
        // Build content
        var pages = itemData.filter(function(page){
          return page.url.indexOf("/pages/") > -1
        })
        var blogs = itemData.filter(function(page){
          return page.url.indexOf("/blogs/") > -1
        })
        if(pages.length > 0){
          result = '<li class="bc-sf-search-suggestion-header-page bc-sf-search-suggestion-header" aria-label="Pages">Pages</li>';
          for (var k in pages) {
            // if (k < itemInfo['number']) {
            var searchResult = this.highlightSuggestionResult(pages[k]['title'], searchTerm);
            result += '<li class="' + this.class.searchSuggestionItem + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(pages[k]['title']) + '">';
            result += '<a href="' + pages[k]['url'] + '">' + searchResult + '</a>';
            result += '</li>';
            // }
          }
        }
        if(blogs.length > 0){
          result += '<li class="bc-sf-search-suggestion-header-page bc-sf-search-suggestion-header" aria-label="Blogs">Blogs</li>';
          for (var k in blogs) {
            // if (k < itemInfo['number']) {
            var searchResult = this.highlightSuggestionResult(blogs[k]['title'], searchTerm);
            result += '<li class="' + this.class.searchSuggestionItem + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(blogs[k]['title']) + '">';
            result += '<a href="' + blogs[k]['url'] + '">' + searchResult + '</a>';
            result += '</li>';
            // }
          }
        }
    }
    return result;
}